import React from "react";
import { Sun, Moon } from "lucide-react";
import InfoHelp from "../help/InfoHelp";
import { pageHelp } from "../help/helpText";
import GlobalSearch from "./GlobalSearch";
import NotificationsBell from "./NotificationsBell";

export default function Header({ title, subtitle, actions }) {
  const [theme, setTheme] = React.useState(() => localStorage.getItem("ceo_theme") || "dark");

  React.useEffect(() => {
    if (theme === "dark") document.documentElement.classList.add("dark");
    else document.documentElement.classList.remove("dark");
    localStorage.setItem("ceo_theme", theme);
  }, [theme]);

  return (
    <header className="sticky top-0 z-30 border-b border-border/70 bg-background/80 backdrop-blur-xl supports-[backdrop-filter]:bg-background/70" data-testid="app-header">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
      <div className="flex min-h-[72px] items-center gap-3 py-3 pl-16 pr-4 sm:pl-16 sm:pr-6 lg:px-8">
        <div className="min-w-0 flex-1">
          {title && <div className="flex items-center gap-1"><h1 className="truncate text-xl font-semibold tracking-[-0.035em] sm:text-2xl" data-testid="page-title">{title}</h1>{(pageHelp[title] || subtitle) && <InfoHelp label={title}>{pageHelp[title] || subtitle}</InfoHelp>}</div>}
          {subtitle && <p className="mt-0.5 hidden max-w-3xl truncate text-xs text-muted-foreground sm:block sm:text-sm">{subtitle}</p>}
        </div>
        <div className="flex shrink-0 items-center gap-2 sm:gap-3">
          <GlobalSearch />
          <NotificationsBell />
          {actions && <div className="flex items-center gap-2">{actions}</div>}
          <button
            type="button"
            aria-label={theme === "dark" ? "Ativar tema claro" : "Ativar tema escuro"}
            title={theme === "dark" ? "Tema claro" : "Tema escuro"}
            data-testid="theme-toggle-btn"
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
            className="grid size-10 place-items-center rounded-xl border border-border/70 bg-card/60 text-muted-foreground shadow-[0_1px_2px_hsl(var(--foreground)/0.03)] transition-all duration-200 hover:border-primary/25 hover:bg-accent hover:text-foreground"
          >
            {theme === "dark" ? <Sun className="size-4" /> : <Moon className="size-4" />}
          </button>
        </div>
      </div>
    </header>
  );
}

